export const parseSearchTerm = (
  searchParams: URLSearchParams
): string | undefined => {
  return searchParams.get("search") || undefined;
};
